import { UserFields } from "~/types/cart";
import Cookies from "js-cookie";
import { Api } from "../../api";
import { cacheFunctionData, getCookieDomain } from "/utils";

export const setErrors = (errors) => {
  return async (dispatch) => {
    dispatch({ type: "SET_ERRORS", payload: errors });
  };
};

export const getDeliveryList = (Redis = false, reset = false) => {
  return async (dispatch) => {
    const response = await Api.cart.getDeliveryList(Redis, reset);
    dispatch({ type: "SET_DELIVERY_LIST", payload: response });
  };
};

export const setDeliveryListAdditional = (list) => {
  return async (dispatch) => {
    dispatch({ type: "SET_DELIVERY_LIST_ADDITIONAL", payload: list });
    dispatch({ type: "SET_DELIVERY_LIST_ADDITIONAL_LOADED", payload: true });
  };
};

export const getPaymentList = (Redis = false, reset = false) => {
  return async (dispatch) => {
    const response = await Api.cart.getPaymentList(Redis, reset);
    dispatch({ type: "SET_PAYMENT_LIST", payload: response });
  };
};

export const getBacket = () => {
  return async (dispatch) => {
    dispatch({ type: "SET_BASKET_LOADING", payload: true });
    const basketFromCache = await cacheFunctionData(
      Api.basket.getBasket,
      "basket",
    );
    dispatch({ type: "SET_BASKET", payload: basketFromCache });
    const basketFromServer = await cacheFunctionData(
      Api.basket.getBasket,
      "basket",
      true,
    );
    dispatch({ type: "SET_BASKET", payload: basketFromServer });
    dispatch({ type: "SET_BASKET_LOADING", payload: false });
    dispatch({ type: "SET_BASKET_LOADED", payload: true });
  };
};

export const setParam = (params) => {
  return async (dispatch) => {
    if (typeof sessionStorage === "object") {
      sessionStorage.setItem("cartParams", JSON.stringify(params));
    }

    if (
      params[UserFields.name] &&
      params[UserFields.phone]?.replace(/\D+/g, "").length === 11
    ) {
      try {
        Cookies.set(
          "userMultiDomainData",
          `${params[UserFields.name]}/${params[UserFields.phone]}`,
          {
            domain: getCookieDomain(),
            path: "/",
          },
        );
        sessionStorage.setItem("cartParams", JSON.stringify(params));
      } catch (e) {
        console.log(e);
      }
    }
    dispatch({ type: "SET_CART_PARAMS", payload: params });
  };
};

export const setStep = (step) => {
  return async (dispatch, getState) => {
    const { cart } = getState();
    if (step > cart.step) {
      dispatch({ type: "SET_ANIMATION", payload: "next" });
    } else {
      dispatch({ type: "SET_ANIMATION", payload: "prev" });
    }

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });
    if (typeof sessionStorage === "object") {
      sessionStorage.setItem("cartStep", JSON.stringify(step));
    }
    dispatch({ type: "SET_STEP", payload: step });
    if (typeof sessionStorage === "object") {
      sessionStorage.setItem("step", step);
    }
    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });
    dispatch({ type: "SET_ANIMATION", payload: "" });
  };
};

export const getStep = () => {
  return async (dispatch) => {
    if (typeof sessionStorage === "object") {
      const step = +sessionStorage.getItem("step");
      if (step) {
        dispatch({ type: "SET_STEP", payload: step });
      }
    }
  };
};

export const getCartData = (user, cityName, regionName) => {
  return async (dispatch) => {
    if (typeof sessionStorage === "object") {
      let cartParams = {};
      try {
        cartParams = JSON.parse(sessionStorage.getItem("cartParams")) || {};
      } catch (e) {
        console.log(e);
      }

      //  delete cartParams[UserFields.recipient];
      if (
        cityName !== cartParams.city_name ||
        regionName !== cartParams.region_name
      ) {
        delete cartParams[UserFields.pointId];
        delete cartParams[UserFields.pointInfo];
        delete cartParams[UserFields.deliveryPrice];
        cartParams.city_name = cityName;
        cartParams.region_name = regionName;
        cartParams[UserFields.city] = `${cityName}, ${regionName}`;
      }

      if (user?.ID) {
        if (user.PHONE) {
          cartParams[UserFields.phone] = user.PHONE;
        }
        if (
          user.NAME &&
          !cartParams[UserFields.name] &&
          user.NAME !== "new user"
        ) {
          cartParams[UserFields.name] = user.NAME;
        }
        if (
          user.EMAIL &&
          !cartParams[UserFields.email] &&
          cartParams.EMAIL !== `${user.PHONE}@farkop.ru`
        ) {
          cartParams[UserFields.email] = user.EMAIL;
        }
      }

      if (!cartParams[UserFields.name] && !cartParams[UserFields.email]) {
        const userMultiDomainData = Cookies.get("userMultiDomainData");
        if (userMultiDomainData && userMultiDomainData.includes("/")) {
          const [name, phone] = userMultiDomainData.split("/");
          if (name && phone?.replace(/\D+/g, "").length === 11) {
            cartParams[UserFields.name] = name;
            cartParams[UserFields.phone] = phone;
          }
        }
      }

      // const cartStep = JSON.parse(sessionStorage.getItem("cartStep"));
      // dispatch({ type: "SET_STEP", payload: cartStep || Steps.step0 });
      dispatch({ type: "SET_CART_PARAMS", payload: cartParams });
      dispatch({ type: "SET_CART_PARAMS_LOADED", payload: true });
    }
  };
};
